module.exports = __webpack_public_path__ + "img/126.aa13efc5.png";